import Cookie from '@component/common/src/util/Cookie';
import Analytics from './js/analytics';


export default class Immersive {
  constructor() {
    this.example = 'example';
    this.Cookies = {
      thirthyDaysInMS: 2592000000,
      oneDayInMS: 86400000,
      bagGuid: 'bloomingdales_bagguid',
      machineId: 'bloomingdales_online',
      mbox: 'mbox',
      latLong: 'USERLL',
      shippingCountry: 'shippingCountry',
      currency: 'currency',
      signedIn: 'SignedIn',
      userGuid: 'bloomingdales_online_guid',
      userId: 'bloomingdales_online_uid',
      bopsPickupInStore: 'BOPSPICKUPSTORE',
      miscGCs: 'MISCGCs',
      bigTicketZip: 'BTZIPCODE',
      zipCode: 'USERPC',
      securityToken: 'secure_user_token',
      dca: 'dca',
      pddST: 'PDDST',
      userST: 'USERST',
      sfl: 'SFL',
    };
  }

  init() {
    this.example = 'initialized';
    this.initEmperia();
    this.initAnalytics();
  }

  initAnalytics() {
    this.utag = new Analytics();
    this.utag.fireViewTag(document.getElementById('main').getAttribute('data-page-tag'));
  }

  initEmperia() {
    window.addEventListener('message', event => this.handleMessage(event), false);
  }

  handleMessage(event) {
    // console.log(`150-emperia-event ${JSON.stringify(event.data)}`);
    switch (event.data.data.event_id) {
      case 'add_to_cart':
        this.sendBagData({
          item: {
            quantity: event.data.data.quantity,
            source: event.data.data.source,
            upcId: event.data.data.upcId,
            upcNumber: event.data.data.upcNumber,
          },
        });
        break;
      case 'checkout':
        window.location = '/my-bag';
        break;
      default:
        // console.log('150-emperia-event default');
    }
  }

  sendBagData(obj) {
    fetch('/xapi/bag/v1/add', {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        'sec-fetch-mode': 'cors',
        'sec-fetch-site': 'same-origin',
      },
      body: JSON.stringify(obj),
    })
      .then(response => response.json())
      .then((json) => {
        this.setCookies(json);
        console.log(`150-add-to-bag: ${json}`);
      });
  }

  setCookies(response) {
    // expire cookie in thirty days
    const expires = new Date(new Date().getTime() + this.Cookies.thirthyDaysInMS);

    // Setting the bagguid cookie manually because it has to be overriden in case the session expires
    if (response.bag.meta.bagGuid) {
      Cookie.set(this.Cookies.bagGuid, response.bag.meta.bagGuid, undefined, {
        expires,
      });
      console.log(`150-setting-cookie bagGuid: ${response.bag.meta.bagGuid}`);
    }

    if (response.bag.meta.userId) {
      Cookie.set(this.Cookies.userId, response.bag.meta.userId, undefined, {
        expires,
      });
      console.log(`150-setting-cookie userId: ${response.bag.meta.userId}`);
    }

    if (response.bag.meta.userGuid) {
      Cookie.set(this.Cookies.userGuid, response.bag.meta.userGuid, undefined, {
        expires,
      });
      console.log(`150-setting-cookie userGuid: ${response.bag.meta.userGuid}`);
    }
    if (response.bag.meta.dca) {
      const expiryDate = new Date(new Date().getTime() + this.Cookies.oneDayInMS);
      Cookie.set(this.Cookies.dca, response.bag.meta.dca, undefined, {
        expiryDate,
      });
      console.log(`150-setting-cookie dca: ${response.bag.meta.dca}`);
    }
  }
}



// WEBPACK FOOTER //
// /opt/jenkins_home/workspace/marketing-campaigns_deploy_trigger_bcom/package/src/immersive.js